export const PREMIUM_CHAT_LOCK_MESSAGE = 'Subscribe for premium model access';

export const chatHasUsedPremium = (chat, messages = [], models = [], selectedModels = []) => {
  const isPremium = (value) => Boolean(value) && models.some((model) =>
    model.isPremium && [model.id, model.name, model.modelString].includes(value)
  );
  // The saved/selected model is already available when the chat opens. Don't
  // wait for messages or make a network request before disabling the composer.
  return isPremium(chat?.model) || selectedModels.some(isPremium) ||
    messages.some((message) => message.role === 'assistant' && isPremium(message.modelUsed));
};

export const isPremiumChatLocked = (chat, messages, models, hasSubscription, selectedModels = []) =>
  !hasSubscription && chatHasUsedPremium(chat, messages, models, selectedModels);
